import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initCommentsSlider = () => {
  const slider = document.querySelector(".comments-swiper");

  slider && new Swiper(slider, {
    speed: 200,
    loop: true,
    lazy: true,
    breakpoints: {      
      1281: {
        slidesPerView: 4.36,
        spaceBetween: 20,
        centeredSlides: true
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 10,
        centeredSlides: true,
      },
      751: {
        centeredSlides: true,
        slidesPerView: 2,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 1.6,
        spaceBetween: 10,
        centeredSlides: false,
      },
      361: {
        slidesPerView: 1.35,
        spaceBetween: 10,
        centeredSlides: false,
      },
      0: {
        slidesPerView: 1.1,
        spaceBetween: 10,
        centeredSlides: true,
      },
    },
    navigation: {
      nextEl: ".comments-swiper__next",
      prevEl: ".comments-swiper__prev",
      disabledClass: "last",
    },
    on: {
      init: function () {
        const totalSlides = this.slides.length;

        let i = 0;

        for (let item of this.slides) {
          item.classList.contains("swiper-slide-duplicate") ? i++ : "";
        }
        document.querySelector(".comments-pagination__total").innerHTML =
          totalSlides - i;
      },
      slideChange: function () {
        const index_currentSlide = this.realIndex + 1;
        document.querySelector(".comments-pagination__current").innerHTML =
          index_currentSlide;
      },
    },
  });

  refreshFsLightbox();
};

export default initCommentsSlider;
